import Component from '../core/Component';
import { queryAll } from "../utils/dom";
import { loadComponents, removeComponents } from '../core/componentUtils'

export default class Ajax extends Component {
    prepare() {
        if (this.element.tagName.toLocaleLowerCase() === "form") {
            this.element.addEventListener('submit', event => {
                if (!event.metaKey) {
                    event.preventDefault();
                    setTimeout(() => {this.submitHandler(event)}, 10);
                }
            });
        } else if(this.element.tagName.toLocaleLowerCase() === "a") {
            this.element.addEventListener('click', event => {
                event.preventDefault();
                this.clickHandler(event);
            });
        } else {
            console.warn('Element is not tag "a" or "form"');
        }
    }

    clickHandler = event => {
        this.element.classList.add('is-loading');

        this.sendRequest({
            url: event.target.href,
        }, response => this.replaceSnippets(response));
    }

    submitHandler = event => {
        if (queryAll('.has-error', this.element).length) {
            console.log('form not valid');
            return;
        }

        // submitted
        let form = event.target;
        let formData = new FormData(form);

        this.element.classList.add('is-loading');

        // send data
        this.sendRequest({
            url: form.action,
            method: form.method,
            data: formData,
        }, response => this.replaceSnippets(response));
    }

    sendRequest = (options, callback) => {
        let defaults = {
            url: window.location.pathname + window.location.search,
            method: "GET",
            data: null
        };

        let data = {
            ...defaults,
            ...options
        };

        let request = new XMLHttpRequest();

        request.onreadystatechange = function() {
            if (request.readyState === 4) {
                if (request.status !== 500) {
                    callback(request.responseText, request);
                } else {
                    callback(null, request);
                }
            }
        }

        request.open(data.method, data.url, true);
        request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        request.send(data.data);
        return request;
    }

    replaceSnippets(response) {
        try {
            let json = JSON.parse(response);

            if (json && json.snippets) {
                Object.keys(json.snippets).forEach(snippetName => {
                    const element = document.getElementById(snippetName);
                    this.replaceSnippet(element, json.snippets[snippetName], snippetName);
                });
            }
        } catch (e) {
            console.warn('Returned response is not a JSON.');
        }
    }

    replaceSnippet(element, newContent, snippetName) {
        this.element.classList.remove('is-loading');

        removeComponents(element);

        if (element.hasAttribute("data-ajax-append")) {
            element.innerHTML = element.innerHTML + newContent;
        } else if (element.hasAttribute("data-ajax-prepend")) {
            element.innerHTML = newContent + element.innerHTML;
        } else if (element.innerHTML !== newContent) {
            element.innerHTML = newContent;
        }

        loadComponents(element);
        console.info(`Updated snippet '${ snippetName }'`);
    }
}